import { CommoditiesTableSectionType } from '../types';
import CommoditiesTableTab from './CommoditiesTableTab';

const CommoditiesTable = ({
  layout,
  sections
}: {
  sections: CommoditiesTableSectionType[] | undefined;
  layout?: { fullWidth?: boolean; height?: number };
}) => {
  return (
    sections && (
      <CommoditiesTableTab
        height={layout?.height}
        sections={sections}
      />
    )
  );
};

export default CommoditiesTable;
